// this file added by Bearer Web Developer
import React, { useRef } from 'react';
import styles from './shortcutOrders.module.scss';
import { useThemeMode } from '../../../../states/contexts/theme';
import { observer } from 'mobx-react-lite';
import { useAppState } from '../../../../states/app-state';
import { useTodayDeliveriesMenu } from '../../../../states/contexts/TodayDeliveries';
import { ShortcutReservedOrdersPlan } from '../../../../states/reservedOrdersState';
const ShortcutOrders: React.FC = observer(() => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const appState = useAppState();
    const { openMenu, anchorEl, positionMenu } = useTodayDeliveriesMenu();
    const openFromLeft = anchorEl && positionMenu === "left";
    const count = Number(appState?.ReservedOrders?.todayReservedOrdersList?.length || 0);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (event?.currentTarget) openMenu(event?.currentTarget, "left");
    }
    // show at first for plan B management start
    const reservedOrdersRef = useRef<HTMLButtonElement | null>(null);
    React.useEffect(() => {
        // console.log({ reservedOrdersRef })
        if (appState?.ReservedOrders?.shortcutReservedOrdersPlan === ShortcutReservedOrdersPlan.ShowAtFirstForPlanB) {
            if (reservedOrdersRef?.current) {
                openMenu(reservedOrdersRef?.current, "left");
            }
        }
    }, []);
    // show at first for plan B management end
    return (
            <button ref={reservedOrdersRef}
                onClick={handleClick} className={styles.today_deliveries_button}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={`${styles.today_deliveries} ${openFromLeft ? styles.open : ''}`}>
                    {
                        openFromLeft ?
                            <img
                                src={
                                    theme === "dark" ? "/cancel.png" :
                                        "/cancel-white.svg"
                                } alt="" width={24} height={24}
                            /> :
                            <img
                                src={
                                    theme === "dark" ? "/calendar-with-watch-black.svg" :
                                        "/calendar-with-watch-blue.svg"
                                } alt="" width={24} height={24}
                            />
                    }
                    {!openFromLeft && <div className={styles.count}>{count}</div>}
                </div>
            </button>
    )
});
export default ShortcutOrders;